import { css } from "@emotion/react";

import { dimensions } from "@styles";

export const list = css`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
  list-style: none;
  margin: 0;
  padding: 0;

  @media (max-width: ${dimensions.tabletMax}) {
    flex-direction: column;
    align-items: center;
  }
`;
